export default __webpack_public_path__ + "static/media/illustration-icon.c0060876.svg";